import { type Notification } from '@/common/hooks/useNotifications'
import * as styles from './NotificationSection.css'

function formatRelativeTime(dateStr: string) {
  const now = Date.now()
  const then = new Date(dateStr).getTime()
  const diffMs = now - then
  const diffMin = Math.floor(diffMs / 60000)
  const diffHr = Math.floor(diffMin / 60)
  const diffDays = Math.floor(diffHr / 24)

  if (diffMin < 1) return 'just now'
  if (diffMin < 60) return `${diffMin}m ago`
  if (diffHr < 24) return `${diffHr}h ago`
  return `${diffDays}d ago`
}

interface NotificationSectionProps {
  notifications: Notification[]
}

export function NotificationSection({ notifications }: NotificationSectionProps) {
  return (
    <div id="notifications" className={styles.section}>
      <h2 className={styles.title}>Notifications</h2>

      {notifications.length === 0 ? (
        <div className={styles.emptyState}>
          No notifications — you're all caught up!
        </div>
      ) : (
        <div className={styles.list}>
          {notifications.map((n) => (
            <div key={n.id} className={styles.item}>
              <div className={styles.itemContent}>
                <span className={styles.itemTitle}>{n.title}</span>
                <span className={styles.itemMessage}>{n.message}</span>
                {n.action_url && (
                  <a href={n.action_url} className={styles.actionLink}>
                    View details
                  </a>
                )}
              </div>
              <span className={styles.itemTime}>
                {formatRelativeTime(n.created_at)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
